import { createContext, useContext, useMemo } from 'react'
import type { ReactNode } from 'react'
import { toast as sonnerToast } from 'sonner'
import { Toaster } from '@/components/ui/sonner'

interface ToastContextValue {
  success: (message: string) => void
  error:   (message: string) => void
  info:    (message: string) => void
}

const ToastContext = createContext<ToastContextValue | null>(null)

export function ToastProvider({ children }: { children: ReactNode }) {
  const value = useMemo<ToastContextValue>(() => ({
    success: (msg) => sonnerToast.success(msg),
    error:   (msg) => sonnerToast.error(msg),
    info:    (msg) => sonnerToast(msg),
  }), [])

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Toaster position="bottom-right" richColors closeButton />
    </ToastContext.Provider>
  )
}

export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>')
  return ctx
}
